<template>
  <div
    :class="_class"
    v-bind="boxProps"
  >
    <!--header-->
    <div :class="_headerClass">
      <ten-checkbox
        :checked="_allChecked"
        :_indeterminate="!_allChecked && _indeterminate"
        :disabled="disabled"
        @change="onCheckAll"
      >
        <span class="ten-transfer__select-box-main-content-item__text">
          {{ selectedKeys.length ? `${selectedKeys.length}/` : '' }}
          {{ `${data.length} ${unit}` }}
        </span>
      </ten-checkbox>
      <span :class="prefixClassName + '-header-title'">{{ title }}</span>
    </div>
    <!--/header-->
    <div :class="_mainClass">
      <ten-select-search
        v-if="filterable"
        :prefix-class.sync="prefixClass"
        :search-value.sync="searchValue"
        :disabled.sync="disabled"
        :index.sync="index"
        :on-search="onSearch"
      />
      <div :class="prefixClassName + '-main-content'">
        <ul
          :class="prefixClassName + '-main-content-list'"
          v-if="!_empty"
        >
          <li
            :class="getItemClass(i, item)"
            v-for="(item, i) in _list"
            :key="i"
            :data-index="i"
            v-on="_itemEvents"
            :draggable="_draggable"
          >
            <ten-checkbox
              :disabled="disabled || item.disabled"
              :checked="selectedKeys.some(key => key === item.key)"
              @change="onChecked(item.key)"
            >
              <span class="ten-transfer__select-box-main-content-item__text">{{
                item.title
              }}</span>
            </ten-checkbox>
          </li>
        </ul>
        <div
          :class="prefixClassName + '-main-notfound'"
          v-else
        >
          <span>暂无数据</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormSize from '../scripts/mixins/form-size';
import WatchCurValue from '../scripts/mixins/wacth-cur-value';
import TenCheckbox from '../checkbox';
import TenSelectSearch from './selectSearch';

const name = 'ten-transfer-selectbox';

export default {
  name,
  components: {
    // Icon,
    TenCheckbox,
    TenSelectSearch,
  },
  mixins: [FormSize, WatchCurValue],
  props: {
    prefixClass: {
      type: String,
    },
    disabled: Boolean,
    draggable: Boolean,
    filterable: Boolean,
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
    },
    searchValue: {
      type: String,
    },
    index: {
      type: Number,
    },
    unit: {
      type: String,
    },
    selectedKeys: {
      type: Array,
      default() {
        return [];
      },
    },
    boxProps: {
      type: Object,
      default: () => ({}),
    },

    onSelectedChange: Function,
    onSearch: Function,
    onDataChange: Function,
  },
  data() {
    return {
      prefixClassName: `${this.prefixClass}__select-box`,
      draggingIndex: null,
      dragoverIndex: null,
      dragoverPos: '',
    };
  },
  computed: {
    _class() {
      const boxPropsClass = this.boxProps.class || '';
      return [
        `${this.prefixClassName}`,
        {
          [`${this.prefixClassName}--disabled`]: this.joinDisabled,
        },
        boxPropsClass,
      ];
    },
    _headerClass() {
      return [
        `${this.prefixClassName}-header`,
        {
          [`${this.prefixClassName}-header--disabled`]: this.joinDisabled,
        },
      ];
    },
    _mainClass() {
      return [
        `${this.prefixClassName}-main`,
        {
          [`${this.prefixClassName}-main--search`]: this.filterable,
        },
      ];
    },
    _draggable() {
      return !this.disabled && this.draggable;
    },
    _itemEvents() {
      if (this._draggable) {
        return {
          dragstart: this.onDragStart,
          dragover: this.onDragOver,
          dragend: this.onDragEnd,
          drop: this.onDrop,
        };
      }
      return {};
    },
    _allChecked() {
      return (
        this.selectedKeys
        && this._selectableListKeys.length > 0
        && this._selectableListKeys.every(key => this.selectedKeys.indexOf(key) > -1)
      );
    },
    _indeterminate() {
      return this._listSelectedKey.length > 0;
    },
    _list() {
      return this.data.filter((item) => {
        if (this.searchValue && item.title.indexOf(this.searchValue) === -1) {
          return false;
        }
        return true;
      });
    },
    _listKeys() {
      return this._list.map(item => item.key);
    },
    _listSelectedKey() {
      return this._listKeys.filter(key => this.selectedKeys.indexOf(key) > -1);
    },
    _selectableList() {
      return this._list.filter(item => !item.disabled);
    },
    _selectableListKeys() {
      return this._selectableList.map(item => item.key);
    },
    _empty() {
      return this._list.length === 0;
    },
  },
  methods: {
    getItemClass(index, item) {
      let dragClass = '';

      if (this.draggable && this.dragoverIndex === index && this.dragoverPos) {
        dragClass = `ten-transfer__select-box-main-content-item--dragpos-${this.dragoverPos}`;
      }

      return [
        'ten-transfer__select-box-main-content-item',
        {
          'ten-transfer__select-box-main-content-item--disabled': item.disabled,
        },
        dragClass,
      ];
    },
    onChecked(key) {
      const selectedKeys = [...this.selectedKeys];
      const index = selectedKeys.indexOf(key);
      if (index > -1) {
        selectedKeys.splice(index, 1);
      } else {
        selectedKeys.push(key);
      }
      this.onSelectedChange(this.index, selectedKeys);
    },
    onCheckAll() {
      let selectedKeys = [...this.selectedKeys];
      if (this._allChecked) {
        selectedKeys = selectedKeys.filter(key => this._selectableListKeys.indexOf(key) === -1);
      } else {
        this._selectableListKeys.forEach((key) => {
          if (selectedKeys.indexOf(key) === -1) {
            selectedKeys.push(key);
          }
        });
      }
      this.onSelectedChange(this.index, selectedKeys);
    },
    onDragStart(e) {
      const index = Number(e.target.dataset.index);
      this.draggingIndex = index;
    },
    onDragOver(e) {
      e.preventDefault();
      const index = Number(e.currentTarget.dataset.index);
      const elemHeight = e.currentTarget.offsetHeight;
      const dragY = e.clientY - e.currentTarget.getBoundingClientRect().top;
      const insertAreaPercent = 0.3;
      const insertAreaHeight = elemHeight * insertAreaPercent;

      this.dragoverIndex = index;

      // console.log('dragging', this.draggingIndex);
      // console.log('draggover', dragY, this.dragoverIndex);
      if (this.dragoverIndex === this.draggingIndex) {
        this.dragoverPos = '';
        return;
      }
      if (dragY < insertAreaHeight) {
        this.dragoverPos = 'top';
      } else if (dragY > elemHeight - insertAreaHeight) {
        this.dragoverPos = 'bottom';
      } else {
        this.dragoverPos = 'center';
      }
    },
    onDragLeave() {
      this.dragoverPos = '';
      this.dragoverIndex = null;
    },
    onDragEnd() {
      this.draggingIndex = null;
      this.dragoverIndex = null;
      this.dragoverPos = '';
    },
    onDrop(e) {
      e.preventDefault();

      const { draggingIndex, dragoverIndex, dragoverPos } = this;

      this.draggingIndex = null;
      this.dragoverIndex = null;
      this.dragoverPos = '';
      if (draggingIndex === dragoverIndex) {
        return;
      }

      const newData = [...this.data];

      // delete
      const sourceItem = this._list[draggingIndex];
      const targetItem = this._list[dragoverIndex];

      const sourceIndex = newData.indexOf(sourceItem);
      let targetIndex = newData.indexOf(targetItem);

      newData.splice(sourceIndex, 1);

      if (draggingIndex < dragoverIndex) {
        targetIndex -= 1;
      }

      if (dragoverPos === 'bottom') {
        targetIndex += 1;
      }
      newData.splice(targetIndex, 0, sourceItem);
      this.onDataChange(newData);
    },
  },
};
</script>
